let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("luD3r")).then(() => parcelRequire('7ykDM'));